import { BaseEvent } from '@packages/shared/core/analytics/events/BaseEvent';
import { BaseEventHandler } from '@packages/shared/core/analytics/events/BaseEventHandler';

export class SRCheatingMainPageGenderOpenedEvent extends BaseEvent {}

export class SRMainPageGenderOpenedEventHandler extends BaseEventHandler {
  shouldTrack(event: BaseEvent): boolean {
    return event instanceof SRCheatingMainPageGenderOpenedEvent;
  }

  async track() {
    return this.amplitudeService.logEvent('registration_gender_start_screen_open');
  }
}
